import { render } from "./ViewDeliveryModal.vue?vue&type=template&id=6ed61a3e"
import script from "./ViewDeliveryModal.vue?vue&type=script&lang=js"
export * from "./ViewDeliveryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__